import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#overview" }),
  /*#__PURE__*/_createTextVNode(" Overview ")
], -1)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://getbootstrap.com/docs/5.0/utilities/borders/",
  class: "fw-bold"
}, "Bootstrap Borders", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("code", null, "src/sass/helpers/_borders.scss", -1)
const _hoisted_8 = { class: "py-10" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-3\" id=\"border-styles\"><a href=\"#border-styles\"></a> Border Styles </h1><div class=\"py-5\"> Use <code>.border-dashed</code> or <code>.border-dotted</code> classes to set an element&#39;s border style. </div><div class=\"py-5\"><div class=\"rounded border p-10\"><div class=\"d-flex flex-wrap align-items-center\"><div class=\"border w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> default style </div><div class=\"border border-dashed w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> .border-dashed </div><div class=\"border border-dotted w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> .border-dotted </div></div></div></div>", 3)
const _hoisted_12 = { class: "py-5" }
const _hoisted_13 = { class: "py-10" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-3\" id=\"border-states\"><a href=\"#border-states\"></a> Border States </h1><div class=\"py-5\"> Use <code>.border-hover</code> to display an element&#39;s border on hover and <code>.border-active</code> to enable the border when <code>.active</code> class is applied. </div><div class=\"py-5\"><div class=\"rounded border p-10\"><div class=\"d-flex flex-wrap align-items-center\"><div class=\"border border-primary border-hover w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> .border-hover </div><div class=\"border border-primary border-active active w-150px h-150px d-flex flex-center me-5 mb-5 fw-bold\"> .border-active<br>.active </div></div></div></div>", 3)
const _hoisted_17 = { class: "py-5" }
const _hoisted_18 = { class: "pt-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "border-gray-colors"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#border-gray-colors" }),
  /*#__PURE__*/_createTextVNode(" Border Gray Colors ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".border-gray-{100, 200, 300, 400, 500, 600, 700, 800, 900}"),
  /*#__PURE__*/_createTextVNode(" to set an element's border color. ")
], -1)
const _hoisted_21 = { class: "py-5" }
const _hoisted_22 = { class: "rounded border p-10" }
const _hoisted_23 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_24 = { class: "pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("b", null, _toDisplayString(_ctx.themeName), 1),
          _createTextVNode(" extends "),
          _hoisted_6,
          _createTextVNode("; in "),
          _hoisted_7,
          _createTextVNode(" to provide additional border utility classes to cover its own design system. ")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="border">default style</div>

            <div class="border border-dashed">.border-dashed</div>

            <div class="border border-dotted">.border-dotted</div>
            `), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="border border-primary border-hover">.border-hover</div>

            <div class="border border-primary border-active active">
              .border-dashed
            </div>
            `), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gray, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass([`border-${item}`, "w-100px h-100px d-flex flex-center p-3 me-5 mb-5 fw-bold border"])
                }, " .border-" + _toDisplayString(item), 3))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div class="border border-gray-100"></div>
            <div class="border border-gray-200"></div>
            <div class="border border-gray-300"></div>
            <div class="border border-gray-400"></div>
            <div class="border border-gray-500"></div>
            <div class="border border-gray-600"></div>
            <div class="border border-gray-700"></div>
            <div class="border border-gray-800"></div>
            <div class="border border-gray-900"></div>
            `))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}